import { isValidDateOnly } from "./date-only.js";

const UUID_PATTERN = /^[a-f\d]{8}-[a-f\d]{4}-[1-5][a-f\d]{3}-[89ab][a-f\d]{3}-[a-f\d]{12}$/i;

export const NORM_TYPES = [
  "all",
  "constitution",
  "international_treaty",
  "law",
  "decree",
  "resolution",
  "disposition",
  "judicial_agreement",
  "regulation",
  "ordinance",
  "other",
];

export const NORM_STATUSES = [
  "all",
  "active",
  "partially_repealed",
  "repealed",
  "suspended",
  "unknown",
];

function pageFrom(parameters) {
  const page = Number(parameters.get("page") || 1);
  return Number.isInteger(page) && page > 0 ? page : 1;
}

export function doctrineSearchFromUrl(search = "") {
  const parameters = new URLSearchParams(search);
  return {
    query: (parameters.get("q") || "").trim(),
    page: pageFrom(parameters),
  };
}

export function buildDoctrineSearchUrl({ query = "", page = 1 } = {}) {
  const parameters = new URLSearchParams();
  const normalizedQuery = query.trim();
  if (normalizedQuery) parameters.set("q", normalizedQuery);
  if (page > 1) parameters.set("page", String(page));
  const serialized = parameters.toString();
  return `/doctrina${serialized ? `?${serialized}` : ""}`;
}

export function normsSearchFromUrl(search = "") {
  const parameters = new URLSearchParams(search);
  const jurisdiction = parameters.get("jurisdiction") || "all";
  const type = parameters.get("type") || "all";
  const status = parameters.get("status") || "all";
  const asOfDate = parameters.get("asOf") || "";
  return {
    query: (parameters.get("q") || "").trim(),
    jurisdiction: jurisdiction === "all" || UUID_PATTERN.test(jurisdiction)
      ? jurisdiction
      : "all",
    type: NORM_TYPES.includes(type) ? type : "all",
    status: NORM_STATUSES.includes(status) ? status : "all",
    asOfDate: isValidDateOnly(asOfDate) ? asOfDate : "",
    page: pageFrom(parameters),
  };
}

export function buildNormsSearchUrl({
  query = "",
  jurisdiction = "all",
  type = "all",
  status = "all",
  asOfDate = "",
  page = 1,
} = {}) {
  const parameters = new URLSearchParams();
  const normalizedQuery = query.trim();
  if (normalizedQuery) parameters.set("q", normalizedQuery);
  if (jurisdiction !== "all") parameters.set("jurisdiction", jurisdiction);
  if (type !== "all") parameters.set("type", type);
  if (status !== "all") parameters.set("status", status);
  if (asOfDate) parameters.set("asOf", asOfDate);
  if (page > 1) parameters.set("page", String(page));
  const serialized = parameters.toString();
  return `/normas${serialized ? `?${serialized}` : ""}`;
}
